import { render, staticRenderFns } from "./YkCampDistributionDefaultTotals.vue?vue&type=template&id=b130698e&"
import script from "./YkCampDistributionDefaultTotals.vue?vue&type=script&lang=js&"
export * from "./YkCampDistributionDefaultTotals.vue?vue&type=script&lang=js&"
import style0 from "./YkCampDistributionDefaultTotals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports